import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { TableRow, TableCell, Button, Input, Dropdown } from "semantic-ui-react";
import { cancelAppointment, setAppointment } from "../queries.jsx";
import { useMutation } from "react-query";
import errorHandler from "../ErrorHandler.jsx"
import { readFromToken } from "../auth.ts"
import { getTimestamp } from "../TimeStamp.jsx";

const UserTableRow = ({ appointment, refetchTable, day }) => {
    const { t } = useTranslation();

    const user_course = readFromToken("course");

    const { start_time, name, course_name, is_disabled, user_email, notes } = appointment;



    const setAppointmentMutation = useMutation(setAppointment, {
        onSettled: (response) => {refetchTable(); errorHandler(response, t)}
    });

    const cancelAppointmentMutation = useMutation(cancelAppointment, {
        onSettled: (response) => {refetchTable(); errorHandler(response, t)}
    });


    const handleSetAppointment = () => {
        if (!nameInput) setNameHasError(true);
        if (!courseNameInput) setCourseHasError(true);
        setAppointmentMutation.mutate({ time: getTimestamp(start_time, day), name: nameInput, course: courseNameInput, notes: notesInput })
    }

    const handleCancelAppointment = () => {
        //setName("");
        //setNotes("");
        //setCourseName(user_course);
        cancelAppointmentMutation.mutate({ time: getTimestamp(start_time, day) });
    }

    const isScheduled = useMemo(() => name !== null, [appointment]);
    
    const [nameInput, setName] = useState(name);
    const [courseNameInput, setCourseName] = useState(isScheduled ? course_name : user_course);
    const [notesInput, setNotes] = useState(isScheduled ? notes : "");
    const [nameHasError, setNameHasError] = useState(false);
    const [courseHasError, setCourseHasError] = useState(false);

    return isScheduled ? (
        <TableRow className="user-table-row" style={{ background: 'lightgreen' }}>
            <TableCell title={start_time}>{start_time}</TableCell>
            <TableCell title={name}>{name}</TableCell>
            <TableCell title={course_name}>{course_name}</TableCell>
            <TableCell title={notes}>{notes}</TableCell>

            <TableCell>
                <div>
                    <Button size="small" color="red" onClick={() => handleCancelAppointment()}>{t('cancel-appointment')}</Button>
                </div>
            </TableCell>
        </TableRow>
    ) : (
        <TableRow className="user-table-row">
            <TableCell width={1}>{start_time}</TableCell>
            <TableCell width={3}>
                <Input error={nameHasError} placeholder={t('name')} value={nameInput} onChange={(_, e) => { setName(e.value); setNameHasError(false); }}/>
            </TableCell>
            <TableCell width={3}>
                <Input error={courseHasError} placeholder={t('course')} value={courseNameInput} onChange={(_, e) => { setCourseName(e.value); setCourseHasError(false); }} />
            </TableCell>
            <TableCell width={3}>
                <Input placeholder={t('notes')} value={notesInput} onChange={(_, e) => { setNotes(e.value); }} ></Input>
            </TableCell>
            <TableCell width={3}>
                <div>
                    <Button size="small" color="blue" onClick={() => handleSetAppointment()}>{t('set-appointment')}</Button>
                </div>
            </TableCell>
        </TableRow>
    );
}

export default UserTableRow;